"use client"

import styled from "@emotion/styled"
import { Container, Desktop, Mobile, NewText } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { sharedColors } from "ui/theme/colors"
import { extractImage, extractProperty } from "utils"

const StyledDiv = styled.div<{ desktopPaddingTop?: string; mobilePaddingTop?: string }>`
  padding-top: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 32px;
  }
`

const StyledImageWrapp = styled.div`
  position: relative;
  height: 340px;
  width: 100%;
  img {
    border-radius: 16px;
    object-fit: cover;
    object-position: top;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 240px;
  }
`

const StyledOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.64) 0%, rgba(0, 0, 0, 0) 100%);
`

const StyledTextWrapper = styled.div`
  position: relative;
  z-index: 2;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 32px;
    padding-right: 32px;
    justify-content: center;
    padding-bottom: 0px;
  }
`

type Props = {
  data: any

  desktopPaddingTop?: string
  mobilePaddingTop?: string
}

function Banner({ data, desktopPaddingTop, mobilePaddingTop }: Props) {
  const bannerImageForDescktop = extractImage(data, "bannerImageForDescktop")
  const bannerImageForMobile = extractImage(data, "bannerImageForMobile")
  const pageTitle = extractProperty(data, "pageTitle")
  const subTitle = extractProperty(data, "subTitle")
  return (
    <Container>
      <StyledDiv desktopPaddingTop={desktopPaddingTop} mobilePaddingTop={mobilePaddingTop}>
        <StyledImageWrapp>
          <Desktop>
            <ImageWithAlt image={bannerImageForDescktop} layout="fill" />
          </Desktop>
          <Mobile>
            <ImageWithAlt image={bannerImageForMobile} layout="fill" />
          </Mobile>
          <StyledOverlay />
          <StyledTextWrapper>
            <NewText
              component={"h1"}
              desktopFontSize={40}
              desktopLineHeight={"44px"}
              desktopFontWeight={400}
              mobileFontSize={32}
              mobileLineHeight={1}
              color={sharedColors.white}
            >
              {pageTitle}
            </NewText>
            <NewText
              component={"h3"}
              desktopFontSize={24}
              desktopLineHeight={"44px"}
              desktopFontWeight={400}
              mobileFontSize={20}
              mobileLineHeight={1}
              color={sharedColors.white}
            >
              {subTitle}
            </NewText>
          </StyledTextWrapper>
        </StyledImageWrapp>
      </StyledDiv>
    </Container>
  )
}
export default Banner
